import { toast } from "react-toastify";
import { amdinAccount, chainID } from "../../config/config";

export const onHandleNFTBuyAction = async(keychain, nft, username, currentNftSymbol) => {
    console.log('[debug] onHandleNFTBuyAction', nft, username);

    let data = {
        "contractName": "nftmarket",
        "contractAction": "buy",
        "contractPayload": {
            "symbol": currentNftSymbol,
            "nfts": [
                nft.nftId.toString()
            ],
            "expPrice": nft.price.toString(),
            "expPriceSymbol": nft.priceSymbol,
            "marketAccount": amdinAccount
        },
        "memo": "extra field"
    };

    keychain.requestCustomJson(username, chainID, "Active", JSON.stringify(data), "Buy NFT", function(response) {
        if (response.success && response.result) {
            //show modal
            toast.success('NFT purchase broadcasted!')
        } else {
            //show modal
            toast.error('Oops, the NFT purchase failed!')
        }
    });
}

export const onHandleNFTBulkBuyAction = async(keychain, nfts, username, currentNftSymbol) => {
    console.log('[debug] onHandleNFTBulkBuyAction', nfts, username);

    let data = {
        "contractName": "nftmarket",
        "contractAction": "buy",
        "contractPayload": {
            "symbol": currentNftSymbol,
            "nfts": nfts,
            "marketAccount": amdinAccount
        },
        "memo": "extra field"
    };

    keychain.requestCustomJson(username, chainID, "Active", JSON.stringify(data), "Buy NFT", function(response) {
        if (response.success && response.result) {
            //show modal
            toast.success('NFT buy success!')
        } else {
            //show modal
            toast.error('Oops, the NFT purchase failed!')
        }
    });
}